import { FC } from 'react';
import styles from './style.module.css';

type Props = {
  full?: boolean;
};

export const Loading: FC<Props> = ({ full = false }) => {
  return (
    <div className={full ? styles.full : undefined}>
      <p className="visually-hidden">読み込み中</p>
      <div className={styles.container}>
        <div className={styles.logo} />
      </div>
    </div>
  );
};
